<app-spinner *ngIf="spin"></app-spinner>
<app-ngx-table type={{service.type}} description="Canned KOZR table manipulates all KOZR robots and their KOZ geometries." [buttonEnabled]="true"
[tableData]="tableData" *ngIf="!spin" (clickedButton)="clickedButtonTable($event)"
(createNew)="newCreation()" (refreshTable)="refreshTableData()"></app-ngx-table>
